/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LevelDto } from './levelDto';

/**
 * Main book pair settings Dto.
 */
export interface MainBookPairStatusDto {
  pairId: number;
  topOfBookSourceId: number;
  levels?: Array<LevelDto>;
}
